import React from 'react';
import { Stack } from 'src/design/atoms/Stack';
import { BaseModal } from 'src/design/molecules/BaseModal';
import { PdfViewer } from 'src/design/organisms/PdfViewer/PdfViewer';
import { WorkflowLogFilterForm } from 'src/app/workflows/WorkflowLogFilterForm';
import { IContact } from 'src/api/models/Organization';

export interface IWorkflowLogModalProps {
  opened: boolean;
  onClose: () => void;
  /** Modal title, e.g. "Change Order Log". */
  title: string;
  /** PDF viewer title, e.g. "Change Order Log PDF". */
  pdfTitle: string;
  statusOptions: string[];
  statuses: string[];
  onStatusChange: (statuses: string[]) => void;
  customerNumber: string;
  contact: IContact | null;
  onContactChange: (contact: IContact | null) => void;
  logUrl: string | null;
  logLoading: boolean;
}

/**
 * @registry Log-PDF modal for the four workflow list pages: a status/contact filter row
 * over a live-rendered log PDF. Callers own the open state and the useWorkflowLogPdf wiring.
 */
export const WorkflowLogModal: React.FC<IWorkflowLogModalProps> = ({
  opened,
  onClose,
  title,
  pdfTitle,
  statusOptions,
  statuses,
  onStatusChange,
  customerNumber,
  contact,
  onContactChange,
  logUrl,
  logLoading,
}) => (
  <BaseModal opened={opened} onClose={onClose} title={title} size="xl">
    <Stack>
      <WorkflowLogFilterForm
        statusOptions={statusOptions}
        statuses={statuses}
        onStatusChange={onStatusChange}
        customerNumber={customerNumber}
        contact={contact}
        onContactChange={onContactChange}
      />
      <PdfViewer src={logUrl} title={pdfTitle} loading={logLoading} />
    </Stack>
  </BaseModal>
);
